/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <a-card :loading="loading" style="margin-bottom:1rem" class="card">
      <div slot="title">
        <a-button
          @click="backButton()"
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
        />
        <router-link :to="`/subscriptions/${this.subscription.id}/edit`">
          <span
            @click="handleEditSubscription()"
            class="hover-title main-card-title"
            >&nbsp;
            <a-icon type="tag"></a-icon>
            {{ subscription.name }}
            <span style="font-size:1rem" class="title-id">
              #{{ subscription.id }}</span
            ></span
          >

          <span class="edit-icon"
            >&nbsp;&nbsp;<a-icon
              type="edit"
              style="font-size:18px; color: #aaa; "
            />
            Configurar</span
          >
        </router-link>

        <!--<a-icon @click="backButton()" type="arrow-left">Volver </a-icon>-->
      </div>
      <!--
      <template class="ant-card-actions" slot="actions">
        <a-icon type="setting" />
        <a-icon type="edit" />
        <a-icon type="ellipsis" />
      </template>
      -->
      <a-switch
        slot="extra"
        style="margin-left:1em"
        checkedChildren="Activa"
        unCheckedChildren="Inactiva"
        defaultChecked
        disabled
      />
      <h3>
        <strong>Suscriptos activos:</strong>&nbsp;<a-icon type="user" />
        {{ subscription.activeSubscribers }}
      </h3>
      <h3>
        <strong>Precio:</strong>
        {{
          new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format(subscription.amount)
        }}

        <span
          v-if="this.subscription.frequencyId == '1'"
          :class="$style.specificationText"
          >/ mes</span
        >
        <span
          v-else-if="subscription.frequencyId == '2'"
          :class="$style.specificationText"
          >/ Año</span
        >&nbsp;
        <a-tag
          color="green"
          style="font-size:13px; cursor:default"
          v-if="this.subscription.freeTrialDays == true"
          >{{ this.subscription.freeTrialDays }} días de prueba</a-tag
        >
      </h3>
      <h3>
        <strong>Vendido:</strong>
        {{
          new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format(subscription.totalSoldCurrentMonth || 0)
        }}
        <span :class="$style.specificationText">
          {{
            new Intl.DateTimeFormat("es-AR", {
              month: "long"
            }).format(new Date())
          }}
        </span>
        /
        <span>
          {{
            new Intl.NumberFormat("es-AR", {
              style: "currency",
              currency: "ARS"
            }).format(subscription.totalSoldLastMonth || 0)
          }}</span
        >
        <span :class="$style.specificationText">
          {{
            new Intl.DateTimeFormat("es-AR", {
              month: "long"
            }).format(new Date().setDate(new Date().getDate() - 30))
          }}
        </span>
        &nbsp;
        <a-tag
          color="green"
          style="font-size:13px; cursor:default"
          v-if="this.subscription.freeTrialDays == true"
          >{{ this.subscription.freeTrialDays }} días de prueba</a-tag
        >
      </h3>
      <h3 :class="$style.specificationText" style="margin-bottom:1rem">
        Creado el
        {{ subscription.createdAt | moment("DD/MM/YYYY") }}
        <a-tag
          style="font-size:13px; cursor:default"
          v-if="this.subscription.endDate != null"
        >
          Finaliza el {{ formatDate(this.subscription.endDate) }}
        </a-tag>
        |
        {{
          new Intl.NumberFormat("es-AR", {
            style: "currency",
            currency: "ARS"
          }).format(subscription.totalSold || 0)
        }}
        total
      </h3>

      <router-link
        :to="`/subscriptions/${this.subscription.id}/subscribers/add`"
      >
        <a-button type="primary" size="small" style="padding-top:2px;">
          <!--<i class="icmn-user-plus" style="margin-right:0.5em" />-->Nuevo
          Suscripto
        </a-button>
      </router-link>
      <router-link :to="`/subscriptions/${this.subscription.id}/edit`">
        <a
          href="javascript: void(0);"
          class="btn btn-link btn-edit-subscription"
        >
          <i class="icmn-cog mr-1" />
          Configuración
        </a>
      </router-link>
      <a-button
        type="primary"
        size="small"
        style="padding-top:1px; font-style:oblique"
        @click="handleLinkButton"
      >
        <i class="icmn-link" style="margin-right:0.5em" />Link de Pago
      </a-button>
    </a-card>

    <subscribers
      :subscriptionId="this.$route.params.id"
      v-if="!addSubscription"
    >
    </subscribers>
  </div>
</template>

<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import Subscribers from "../SubscribersList";
import Vue from "vue";
import utils from "@/services/utils";

export default {
  name: "subscriptionDetails", //necesita tener un name para que funcione el <keep-alive>
  data() {
    return {
      loading: true,
      editIcon: false,
      subscription: {
        id: null,
        name: null,
        frequencyId: "",
        freeTrialDays: null,
        costCenter: {
          id: null,
          name: null,
          costCenterType: { name: null }
        },
        businessUnit: {
          id: null,
          name: null
        },
        dictionary: {
          costCenters: [
            {
              id: null,
              name: null,
              costCenterType: { name: null }
            }
          ],
          businessUnits: [
            {
              id: null,
              name: null
            }
          ]
        },
        linkToken: null
      },
      dateFormat: "DD/MM/YYYY",
      addSubscription: false,
      editSubscription: false,
      cascaderOptions: [
        {
          value: "tupaggo",
          label: "Tupaggo",
          isLeaf: false
        },
        {
          value: "harmony",
          label: "Harmony",
          isLeaf: false,
          children: [
            {
              value: "course",
              label: "Curso",
              isLeaf: false
            },
            {
              value: "event",
              label: "Evento",
              isLeaf: false
            }
          ]
        }
      ],
      options: []
    };
  },
  props: ["subscriptionId"],
  components: {
    subscribers: Subscribers
  },
  methods: {
    ...mapActions({
      loadSubscription: "subscriptions/loadOne",
      generateLinkToken: "subscriptions/generateLinkToken"
    }),
    backButton() {
      //this.$emit("backClick");
      this.$router.push(`/subscriptions`);
    },
    async fetchSubscription() {
      try {
        //console.log("params:", params);
        //const id = this.$router.params.id
        this.loading = true;
        const result = await this.loadSubscription(this.$route.params.id);
        this.loading = false;
        this.subscription = store.state.subscriptions.subscriptionDetails;
      } catch (error) {
        this.loading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    formatDate(date) {
      if (date) {
        const d = new Date(date);
        return d.toLocaleDateString();
      } else return null;
    },
    handleEditSubscription() {
      this.editSubscription = true;

      //alert("hola");
    },
    onCascaderChange(value) {
      console.log(value);
    },
    async loadCascaderData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let res, offset, limit, totalPages, options, tempOptions;
      try {
        if (targetOption.value == "tupaggo") {
          res = await Vue.prototype.$axios.get(`/admin/cost-centers`);
          if (res.data) {
            options = new Array();
            res.data.results.forEach(item => {
              options.push({
                label: `${item.costCenterType.name} - ${item.name}`,
                value: item.id.toString()
              });
            });
          }
        } else if (targetOption.value == "course") {
          offset = 1; //en harmony offset es el page
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_COURSES_SEARCH_API_KEY;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/courses`, {
              params: {
                type: "country",
                country: "ar",
                language: "es-ar",
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (!tempOptions[item.title])
                  tempOptions[item.title] = new Array();
                if (item.course_id.trim() != "") {
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          options = new Array();
          for (var key in tempOptions) {
            tempOptions[key].sort((a, b) => {
              if (a.value < b.value) {
                return -1;
              } else return 1;
            });
            options = options.concat(tempOptions[key]);
          }
        } else if (targetOption.value == "event") {
          offset = 1;
          limit = 100;
          totalPages = 1;
          tempOptions = new Array();

          Vue.prototype.$axiosHarmony.defaults.headers.common["Authorization"] =
            process.env.VUE_APP_HARMONY_EVENTS_SEARCH_API_KEY;

          for (offset = 1; offset <= totalPages; offset++) {
            res = await Vue.prototype.$axiosHarmony.get(`/events`, {
              params: {
                type: "country",
                country: "ar",
                limit,
                offset
              }
            });
            if (res.data) {
              res.data.courses.forEach(item => {
                if (item.course_id.trim() != "") {
                  if (!tempOptions[item.title])
                    tempOptions[item.title] = new Array();
                  tempOptions[item.title].push({
                    label: `${item.title} - ${item.course_id}`,
                    value: item.course_id
                  });
                }
              });
              totalPages = Math.ceil(res.data.total / limit);
            }
          }
          options = new Array();
          for (var key2 in tempOptions) {
            tempOptions[key2].sort((a, b) => {
              if (a.value < b.value) {
                return -1;
              } else return 1;
            });
            options = options.concat(tempOptions[key2]);
          }
        }
        targetOption.children = options;
        this.cascaderOptions = [...this.cascaderOptions];
        targetOption.loading = false;
      } catch (error) {
        targetOption.loading = false;
        console.log(error);
        throw error;
      }
    },
    handleBusinessUnitChange() {},
    handleRoute() {
      if (this.$route.name == "subscriptionDetails") this.fetchSubscription();
      else if (this.$route.name == "subscriptionDetailsAdd")
        this.addSubscription = true;
      else if (this.$route.path.indexOf("/edit") > 0) {
        this.editSubscription = true;
        this.fetchSubscription();
      }
    },
    async handleLinkButton() {
      const linkToken = await this.generateLinkToken(this.$route.params.id);

      utils.copyToClipboard(
        `${process.env.VUE_APP_SUBSCRIPTION_BASE_URL}/${linkToken}`
      );
      this.$notification["success"]({
        message: "Link copiado.",
        description:
          "Para pegarlo tipea ctrl + v en el teclado o elije la opción 'Pegar' con el botón derecho del mouse."
      });
    }
  },
  mounted() {
    this.handleRoute();
  },
  watch: {
    //REACTIVE TO URL CHANGE
    $route(to) {
      this.handleRoute();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
</style>

<style lang="css">
.ant-card {
  border-radius: 7px;
}
.ant-card-head-title {
}
.ant-card-body {
  padding-bottom: 9px;
  padding: 17px 32px;
}
.ant-list-item-action {
  margin-top: 1rem;
}
.ant-dropdown-link {
  text-transform: none;
  font-weight: 400;
}
.ant-card-head {
  min-height: 44px;
}
.ant-card-head-wrapper {
  flex-direction: row;
}
.ant-card-extra,
.ant-card-head-title {
  padding-top: 13px;
  padding-bottom: 9px;
}
.ant-tag {
  vertical-align: middle;
}
h4:hover {
  color: #0190fe;
  cursor: pointer;
}
.anticon {
  vertical-align: -0.2rem;
}
.ant-tag {
  vertical-align: 0.2rem;
}

/*
.ant-collapse > .ant-collapse-item > .ant-collapse-header .arrow {
  left: 0;
  line-height: 0;
}
.ant-collapse > .ant-collapse-item > .ant-collapse-header {
  padding-left: 20px;
}
.ant-btn-link {
  border: none;
}
*/
.back-button {
  /*background-color: #fff;
  border-color: #777;
  color: #777;*/
  vertical-align: 0.38rem;
}
/*
.back-button:hover {
  background-color: #0190fe;
  border-color: #0190fe;
  color: #fff;
}*/
.back-button .anticon {
  vertical-align: -0.213rem;
}
.ant-collapse-item {
  border-bottom: none !important;
}
/*
h3 {
  font-size: 1.2rem;
}
strong {
  font-weight: normal;
  color: black;
}*/
@media (max-width: 767px) {
  .ant-card-head-wrapper {
  }
  .ant-card-head-title {
    flex-grow: 5;
    /*font-size: 100%;*/
    width: 25rem;
  }
  .ant-card-extra {
    float: inherit !important;
    margin-left: 1rem !important;
    align-self: flex-end;
    vertical-align: middle;
    padding-bottom: 1.28rem;
  }
  .ant-switch {
    margin-left: 0 !important;
  }
  .title-id {
    display: none;
  }
  .hover-title {
    font-size: 1.7rem;
    letter-spacing: -1px;
  }
  .hover-title + .edit-icon {
    display: inline;
  }
  .edit-subscription-button {
    display: inline !important;
  }
  .edit-icon {
    display: none !important;
  }
}
.edit-icon {
  display: none;
  font-size: 13px;
  color: #aaa;
  vertical-align: -0rem;
}
.hover-title {
  cursor: pointer;
}
.hover-title:hover + .edit-icon {
  display: inline;
}
.btn-edit-subscription {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
